const TmpPE015 = (page) => {
  const images = [];
  const media = [];
  const modifiedPage = {
    ...page
  };

  page.content.core.forEach((decision, index) => {
    // modify the media object from the page data
    const decisionMedia = {
      size: '960px X 540px',
      ...decision.media,
      id: page.id + '-' + index,
      page: page.id,
      src: page.label.toLowerCase().replaceAll('-', '_') + '_' + index + '.jpg'
    };
    // add the media object to the media array
    media.push(decisionMedia);
    // modify the media object to strip out the unnecessary data
    delete decisionMedia.author_desc_en;
    delete decisionMedia.author_desc_tl;
    delete decisionMedia.transcript;
    delete decisionMedia.display_content;
    delete decisionMedia.media_url;
    // push the modified media object to the images array
    // images.push(decisionMedia);
    // update the media object in te modified page data
    modifiedPage.content.core[index].media = decisionMedia;

    modifiedPage.content.core[index].section_id = page.id;
  });

  // Inject page.id into each focus point if present
  if (Array.isArray(page.focusPointsData)) {
    page.focusPointsData.forEach((fp) => {
      fp.page = page.id;
    });
  }

  // Extract metadata separately
  const metadata = {
    media: media || [],
    images: images || [],
    materials: page.materialsData || [],
    eMentor: page.eMentorData || [],
    focusPoints: page.focusPointsData || []
  };

  return { modifiedPage, metadata };
};

export default TmpPE015;
